import usePDPContext from './usePDPContext';

const usePdpIsModularBYOProduct = () =>
  usePDPContext()?.pdpIsModularBYOProduct ?? false;

export default usePdpIsModularBYOProduct;
